<table class="table-primary">
  <thead>
  <tr>
    <th (click)="sortByColumn('shippedDate')" class="text-left sort processed" scope="col">
      Ship Date
      <img [class.asc]="tableColumns.shippedDate" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
    </th>
    <th (click)="sortByColumn('receivedDate')" class="text-left sort received" scope="col">
      DATE/TIME
      <img [class.asc]="tableColumns.receivedDate" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
    </th>
    <th (click)="sortByColumn('wholesalerName')" class="text-left sort wholesaler" scope="col">
      Wholesaler
      <img [class.asc]="tableColumns.wholesalerName" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
    </th>
    <th (click)="sortByColumn('purchaseOrder')" class="text-right sort po-number" scope="col">
      PO Num
      <img [class.asc]="tableColumns.purchaseOrder" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
    </th>
    <th (click)="sortByColumn('invoiceNumber')" class="text-right sort invoice-number" scope="col">
      Invoice Num
      <img [class.asc]="tableColumns.invoiceNumber" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
    </th>
    <th (click)="sortByColumn('csos')" class="text-right sort invoice-number" scope="col">
      CSOS
      <img [class.asc]="tableColumns.csos" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
    </th>
    <th (click)="sortByColumn('ndcCount')" class="text-right sort ndcs" scope="col">
      Ndcs
      <img [class.asc]="tableColumns.ndcCount" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
    </th>
    <th (click)="sortByColumn('orderStatus')" class="text-right sort status" scope="col">
      Status
      <img [class.asc]="tableColumns.orderStatus" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
    </th>
    <th class="text-right controls" scope="col">
      <!--Controls-->
    </th>
  </tr>
  </thead>
  <tbody>
  <tr class="table-row" *ngFor="let rowData of ordersHistoryList; let i = index;">
    <th class="text-left received" scope="row">
      {{rowData?.shippedDate | date}}
    </th>
    <th class="text-left received" scope="row">
      <div class="heading">
        {{rowData?.receivedDate | formattedDate: 'MMM d a, HH:mm yyyy'}}
      </div>
      <div class="secondary">
        {{rowData?.userFirstName}} <ng-container *ngIf="rowData?.userLastName && rowData?.userLastName[0]">{{rowData.userLastName[0]}}.</ng-container>
      </div>
    </th>
    <td class="text-left wholesaler">{{rowData?.wholesalerName}}</td>
    <td class="text-right po-number">{{rowData?.purchaseOrder}}</td>
    <td class="text-right invoice-number">{{rowData?.invoiceNumber || 'N/A'}}</td>
    <td class="text-right invoice-number">{{rowData?.csos}}</td>
    <td class="text-right ndcs">{{rowData?.ndcCount | number}}</td>
    <td class="text-right status">
      <app-badge *ngIf="rowData.orderStatus === OrderHistoryStatusesEnum.Received" [color]="BadgeColorsEnum.Green">
        Received
      </app-badge>
      <app-badge *ngIf="rowData.orderStatus === OrderHistoryStatusesEnum.NotReceived" [color]="BadgeColorsEnum.Red">
        Not Received
      </app-badge>
    </td>
    <td class="text-right controls">
      <button *ngIf="rowData.orderStatus === OrderHistoryStatusesEnum.Received"
              (click)="goToDetails(rowData?.id)"
              [disabled]="loading"
              class="details-btn animation-focus-default"
      >
        Details
      </button>
      <app-button *ngIf="rowData.orderStatus === OrderHistoryStatusesEnum.NotReceived"
                  (clicked)="receiveOrder(rowData.id)"
                  [disabled]="loading"
                  subStyle="white"
                  customClasses="px-4"
                  class="receive-order-btn"
      >
        Receive Order
      </app-button>
    </td>
  </tr>
  </tbody>
</table>
